import type { IconSvgObject } from './types';

const StepIntoIcon: IconSvgObject = [
  ["path", { d: "M3 20H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 20H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 4H9.52344C10.628 4 11.5234 4.89543 11.5234 6V16.2141M14 14.5244L11.5234 17.0012L9 14.5244", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StepIntoIcon;
